import { render, staticRenderFns } from "./EcommerceCompanyTable.vue?vue&type=template&id=ab37570a&scoped=true&"
import script from "./EcommerceCompanyTable.vue?vue&type=script&lang=js&"
export * from "./EcommerceCompanyTable.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceCompanyTable.vue?vue&type=style&index=0&id=ab37570a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab37570a",
  null
  
)

export default component.exports